/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/fridge'
export default icon
